// autoFix.js
// 设计图纸为1920*1080
export function pagePc () {
  const rootValue = 100
  const pc = rootValue / 1920 // 表示1366的设计图,使用90px的默认值
  let width = window.screen.width // 当前窗口的宽度
  const height = window.screen.height // 当前窗口的高度
  let rem = ''
  const currentHeight = (width * 1080) / 1920
  if (height < currentHeight) {
    // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
    width = (height * 1920) / 1080
  }
  rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
  document.documentElement.style.fontSize = rem + 'px'
}

pagePc()

window.onresize = function () {
  pagePc()
}
